module.exports = __webpack_public_path__ + "static/media/statements.c3c8172b.svg";